<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Arm Chair Springs</h2>
        <!-- <h3>Placeholder</h3> -->

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml">
            <photo
              @setFeature="setFeatureImg"
              src="armchair-springs1@1x.jpg"
              src2="armchair-springs1@2x.jpg"
              alt="Arm Char springs closeup"
            />
            <photo
              @setFeature="setFeatureImg"
              src="armchair-springs2@1x.jpg"
              src2="armchair-springs2@2x.jpg"
              alt="Arm Char springs full shot"
            />
            <photo
              @setFeature="setFeatureImg"
              src="armchair-springs3@1x.jpg"
              src2="armchair-springs3@2x.jpg"
              alt="Arm Char springs in action"
            />
          </photo-grid>

          <cta-prod-button
            class="cta-button wide"
            link="arm-chair"
            src="contrology-chair1@1x.jpg"
            src2="contrology-chair1@2x.jpg"
            alt="Close-up photo of Contrology Chair thumbnail"
            productName="Contrology Arm Chair"
          />

          <div class="content-wrapper">
            <section class="intro">
              <h2>Arm Chair Springs</h2>
              <!-- <h3>Placeholder</h3> -->
              <p>
                This spring is the lightest of the Contrology springs. It was designed after Jay Grimes' Vintage Arm Chair Springs, providing just the right amount of resistance.
                <br><br>
                This spring has a "neck down" design which means that there are reduced coils at the tip of the spring. When combined with the wider coils in the body of the spring, it ends up acting as 2 springs in one. 
                <!-- <span
                  v-show="!show"
                  class="content-link"
                  @click="toggleContent"
                  role="button"
                  tabindex="0"
                >
                  More ›
                </span> -->
              </p>
              <!-- <div v-show="show">
                <p>
                  This spring has the "neck down" design which means that there are reduced coils at the tip of the spring. When combined with the wider coils in the body of the spring it ends up acting as 2 springs in one. 
                  <span
                    v-show="show"
                    class="content-link"
                    @click="toggleContent"
                    role="button"
                    tabindex="0"
                  >
                    Less ›
                  </span>
                </p>
              </div> -->
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
            />

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >2 Year Limited Warranty</icon-link>
              <icon-link
                url="support"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
            </section>

            <modal-card-large v-if="showCardModal" @close="showCardModal = false" />

            <cta-prod-button
              class="cta-button"
              link="reformer"
              src="contrology-ref1@1x.jpg"
              src2="contrology-ref1@2x.jpg"
              alt="Close-up photo of Contrology Reformer thumbnail"
              productName="Contrology Reformer"
              productSub=''
            />

            <section class="more">
              <tertiary-button text="More Arm Chair Accessories" url="/accessories/Arm Chair" />
            </section>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import ModalCardLarge from "@/components/ModalCardLarge.vue";
import CtaProdButton from "@/components/CtaProdButton.vue";
import TertiaryButton from "@/components/TertiaryButton.vue";

export default {
  name: "armchairsprings",

  metaInfo: {
    title: "Contrology Arm Chair Springs - Balanced Body Chair Springs",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "Designed after Jay Grimes' Vintage Arm Chair Springs, this Contrology Arm Chair Spring is the lightest of the Contrology Springs. Get your pilates springs today."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    ModalCardLarge,
    CtaProdButton,
    TertiaryButton
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      show: false, // Intro content
      product: {
        label: "Select",
        value: "",
        key: "name"
      },
      option1: {},
      option2: {},
      products: [
        // Product options
        {
          prodid: 41267984564417,
          partnumber: 16909,
          price: 32,
          name: "Arm Chair Spring, single",
          available: true
        },
        {
          prodid: 41267984597185,
          partnumber: 17880,
          price: 60,
          name: "Arm Chair Springs, pair",
          available: true
        }
      ]
    };
  },
  
  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.krn-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  max-width: 530px;
  margin: 0 auto;
  margin-top: 3rem;
}

.krn-image-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
  padding-right: 0;
}

.krn-image-container img {
  width: 180px;
  height: 180px;
}

.krn-image-container p {
  font-size: 10px;
  margin: 1rem 0 0 0;
}

.krn-quote-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 2rem 0;
}

.krn-quote {
  margin-bottom: 24px;
  margin-top: 0;
  font-size: 18px;
  font-family: var(--noto);
  font-style: italic;
}

.krn-name {
  font-weight: 500;
  font-size: 15px;
  margin: 0;
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 100%;
    left: 10%;
    width: 80%;
    margin: 0 auto;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 20px 0 10px;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  ::v-deep .modal-card-wrapper {
    top: 60%;
  }

  .icon-link {
    margin: 0;
  }

  .more {
    order: 5;
    margin-top: 20px;
  }

  .krn-container {
    max-width: 775px;
  }

  .krn-container {
    flex-direction: row;
  }

  .krn-image-container {
    margin: 0;
    padding-right: 2rem;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  ::v-deep .modal-card-wrapper {
    top: 20px;
  }

  .icon-link {
    margin: 1px;
  }
}
</style>
